<nav>
    <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item pe-1">
            <span class="nav-link fw-bold active" *ngIf="isForTestEntries" jhiTranslate="head-to-head-query.test.label">
                TEST
            </span>
            <span class="nav-link fw-bold active" *ngIf="!isForTestEntries" jhiTranslate="head-to-head-query.standard.label">
                STANDARD
            </span>
        </li>
    </ul>
    <div class="tab-content">
        <div role="tabpanel" class="tab-pane container-fluid active">
            <br>
            @if (isForTestEntries) {
				<div class="mb-3">
					<div class="button-row">
						<div class="flex-sm-fill">
							<span jhiTranslate="head-to-head-query.specify.test.entries"></span>
						</div>
						<button class="btn btn-info btn-responsive" (click)="openGermplasmSelector('test')">
							<span jhiTranslate="head-to-head-query.search.germplasm.button"></span>
						</button>
					</div>
					<div class="button-row">
						<div class="flex-sm-fill">
							<span jhiTranslate="head-to-head-query.specify.test.list"></span>
						</div>
						<button class="btn btn-info btn-responsive" (click)="browseList()">
							<span jhiTranslate="head-to-head-query.browse.list.button"></span>
						</button>
					</div>
				</div>
            } @else {
                <div class="mb-3">
					<div class="button-row">
						<div class="flex-sm-fill">
							<span jhiTranslate="head-to-head-query.specify.standard.entries"></span>
						</div>
						<button class="btn btn-info btn-responsive" (click)="openGermplasmSelector('standard')">
							<span jhiTranslate="head-to-head-query.search.germplasm.button"></span>
						</button>
					</div>
					<div class="button-row">
						<div class="flex-sm-fill">
							<span jhiTranslate="head-to-head-query.specify.standard.list"></span>
						</div>
						<button class="btn btn-info btn-responsive" (click)="browseList()">
							<span jhiTranslate="head-to-head-query.browse.list.button"></span>
						</button>
					</div>
                </div>
            }
            <br>
        </div>
    </div>
</nav>
